<footer id="footer" class="bg-color-quaternary">
    <div class="container" *ngIf="compFooter" [innerHTML]="compFooter.Content | keepHtml">
        
    </div>
</footer>